import React from 'react';
import axios from 'axios';
import { isRouteErrorResponse, useRouteError } from 'react-router-dom';

import s from './ErrorPage.module.scss';

export const ErrorPage = (): JSX.Element => {
  const error = useRouteError();

  let statusCode;
  if (axios.isAxiosError(error) && error.response) {
    statusCode = error.response.status;
  } else if (isRouteErrorResponse(error)) {
    statusCode = error.status;
  }

  return (
    <div className={s.image}>
      <div className={s.image__errorText}>
        {statusCode && <div>{statusCode}</div>}
        <p className={s.image__announce}>Eitthvað fór úrskeiðis!</p>
      </div>
    </div>
  );
};
